import {ChangeDetectorRef, Component, Input, OnInit,LOCALE_ID } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import {
   ListeService, StateService, DialogService,
    FormulaireService,ParameterService,PageService
} from "../../../../../services"
import { of,Observable, Subject,  } from 'rxjs'
import { SaveFiltersDialog } from '../../../../partials/layout/dialogs/save-filters-dialog/save-filters-dialog.component'
import { LoadDialogComponent } from '../../../../partials/layout/dialogs/load-dialog/load.component'

import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';

import { DateAdapter, MatDatepickerInputEvent , MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';


const KEY = "dossier-page-synthese"

@Component({
    selector: "atyl-dossier-page-synthese",
    templateUrl: "./dossier-page-synthese.component.html",
    styleUrls: ["./dossier-page-synthese.component.scss"]	,
		 providers: [
	    { provide: LOCALE_ID, useValue: 'fr-FR' },
	    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
	    {
	      provide: DateAdapter,
	      useClass: MomentDateAdapter,
	      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
	    },
	    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
	    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
	    {
	      provide: MAT_DATE_FORMATS, useValue: {
	        parse: {
	          dateInput: 'L',
	        },
	        display: {
	          dateInput: 'L',
	          monthYearLabel: 'MMM YYYY',
	          dateA11yLabel: 'L',
	          monthYearA11yLabel: 'MMM YYYY',
	        },
	      }
	    },
	  ],
})
@Stringable({
    path: "views/pages/recherche/tabs/synthese",
    key: KEY,
})
export class DossierPageSyntheseComponent implements OnInit {

    listCode:string="SYNTHESE"
    listCodePage:string="SYNTHESE_FILTRE"

	@StringableValues(KEY) strings: any
    loading: boolean=false;
    @Input() eventLoad: Observable<boolean>;
   
    @Input() dossier: any
    
    actions: any[] = [];
    listpressets: any[] = [];
    advanceVisibility: boolean = false;
    
    dem_forms:any[]=[];
	all_datas:any={};
	
    formularies:any[]=[];
    dataFormInput:any;
    
    typeInstru:any[]=[];
    dataInstructionInput:any;
    
    dataAndInput:boolean=true;
    dataLimitSynthisInput:boolean=true;
    dataLimitFilledInput:boolean=true;
	dataInstuctionCourseInput:boolean=false;
	
	dataDateBeginEndInput:any;
	dataDateBeginInput:any;
		
	private eventsSubscription: any
	subs:any[]=[];
	
	sorts:any[]=[
		{"id":"formulaire_creation","direction":"DESC","label":"Date Examen décroissant"},
		{"id":"formulaire_creation","direction":"ASC","label":"Date Examen croissant"},
		{"id":"formulaire_libelle","direction":"ASC","label":"Formulaire croissant"},
		{"id":"formulaire_libelle","direction":"DESC","label":"Formulaire décroissant"}
	];
	sortInput:any=this.sorts[0];
	
	_options:any={
		     filters:{},
		     sorts:[]
	};
    constructor(
	    private dialogService: DialogService,
	    private parameterService: ParameterService,
	    private formulaireService: FormulaireService,
        private listService: ListeService,
         private pageService: PageService,
        private stateService: StateService,
        private changeDetectorRef: ChangeDetectorRef,
    ) { }

    ngOnInit() {
	
		//this.getFilters();
		
		
	
        this.stateService.dossier.subscribe((dossier: any) => {
            if (dossier) {
                this.dossier = dossier
                
            }
        })
        /*
        let _otionform={
			onlyForm: true
		}
		
        this.formulaireService.list(_otionform).subscribe(
			(res: JSONRpcResponse) => {
				if (res.result) {
					for(let i=0;i<res.result.length;i++)
					   res.result[i].count=0;
					
					this.formularies=res.result;
					 this.changeDetectorRef.detectChanges();
				}	
			}
		);
        
        this.loadTypeInstru();
        */
       
        
        this.eventsSubscription =this.eventLoad.subscribe((loading:boolean) => {
			if (!loading) {
				          this.subs.forEach((sb)=> {
									sb.unsubscribe(); 
							})
			}		 
			else {
					
					this.getFilters();
					this.getStoredFilters();
					
					let _otionform={
					onlyForm: true,
					onlyActive: true
					}
				
			        this.subs.push(
					this.formulaireService.list(_otionform).subscribe(
						(res: JSONRpcResponse) => {
							if (res.result) {
								for(let i=0;i<res.result.length;i++)
								   res.result[i].count=0;
								
								this.formularies=res.result;
								
								 this.changeDetectorRef.detectChanges();
								 this.loadTypeInstru(loading);
							}	
						}
						)
				);
	        }
	        
	
			
	     });
		
    }
	ngOnDestroy() {
		      this.eventsSubscription.unsubscribe();
			   this.subs.forEach((sb)=> {
			   								sb.unsubscribe(); 
			   	})
	}
    
    loadTypeInstru(loading:boolean) {
	    this.typeInstru=[];
	    
	    let _otionIns={
			onlyActive: true
		}
		this.subs.push(
			this.parameterService.getTypeInstruction(_otionIns)
				.subscribe((list: JSONRpcResponse) => {
					for (var i = 0; i < list.result.length; i++) {
						list.result[i].count=0;
						this.typeInstru.push(list.result[i])
					}	
					this.loadData(null,loading);
					 this.changeDetectorRef.detectChanges();	
				})
		);	
	}
    
    
    setStatictics(meta:any) {
		console.log("synthese setStatictics",meta,this.formularies,this.typeInstru)
	     if (meta.forms!=undefined ||
	       meta.instructions!=undefined
	     ) {
		    let torefres:boolean=false;
		    if (meta.forms!=undefined) {
				console.log("synthese setStatictics form", meta.forms,this.formularies)
			    for(let i=0;i<this.formularies.length;i++) {
				   if (meta.forms[this.formularies[i].key]!=undefined) {
				         this.formularies[i].count=meta.forms[this.formularies[i].key];
				         torefres=true;
				    }
				
			    }
		    }
		     if (meta.instructions!=undefined) {
			   console.log("synthese setStatictics instruction",meta.instructions,this.typeInstru)
			    for(let i=0;i<this.typeInstru.length;i++) {
				   if (meta.instructions[this.typeInstru[i].key]!=undefined) {
				         this.typeInstru[i].count=meta.instructions[this.typeInstru[i].key];
				         torefres=true;
				    }
				
			  }
		    }
		    if (torefres)
		         this.changeDetectorRef.detectChanges();
	     }
    }
    
    addFilter(key:string,value:any) {
	   let filter={
		   
			value:value
	   };
	   
	   this._options.filters[key]=filter;
	   
	}
	
	addFilterForm() {
		let values:string[]=[];
		if (this.dataFormInput!=undefined
		&& this.dataFormInput.length>0
		) {
			
			for(let i=0;i<this.dataFormInput.length;i++)
			   values.push(this.dataFormInput[i].key);
			
	   }
	   this.addFilter("formulaire",values);
	   
	}
	
	addFilterInstru() {
		let values:string[]=[];
		if (this. dataInstructionInput!=undefined
		&& this. dataInstructionInput.length>0
		) {
			
			for(let i=0;i<this. dataInstructionInput.length;i++)
			   values.push(this.dataInstructionInput[i].key);
			
	   }
	   this.addFilter("instruction",values);
	   
	}
	
	setSort() {
		if (this.sortInput!=undefined)
			this._options.sorts=[this.sortInput];
	}
	
	addFilters() {
		this.addFilter("dossier",this.dossier.ID);
		this.addFilter("and",this.dataAndInput);
		this.addFilter("synthesis",this.dataLimitSynthisInput);
		this.addFilter("filled",this.dataLimitFilledInput);
		this.addFilter("oncourse",this.dataInstuctionCourseInput);
		this.addFilter("begin",this.dataDateBeginInput);
		this.addFilter("beginend",this.dataDateBeginEndInput);
				
	    this.addFilterForm();
	    this.addFilterInstru();
		
		this.setSort();
	}
	
	removeFilter(key:string) {
		if (this._options.filters[key]!=undefined)
		   this._options.filters[key]=undefined;
	}
	
	loadData(event:any,loading:boolean=true) {
		this.loading=loading;
			if (this.loading) {
				
				
				this.dem_forms=[];
				this.all_datas={};
				
				this.addFilters();
				this.subs.push(
					this.listService.get(this.listCode,this._options).subscribe(
					     (res: JSONRpcResponse) => {
		                    console.log("listService SYNTHESE",res);  
		                    
		                    if (res.result
		                    && res.result.datas!=undefined
		                    && res.result.datas.datas!=undefined
		                    ) {
								this.dem_forms= res.result.datas.datas;
								this.all_datas=res.result.datas;
		                    }
		                    if (res.result
		                    && res.result.datas!=undefined
		                    &&  res.result.datas.meta!=undefined
		                     &&  res.result.datas.meta.statistics!=undefined
		                    )
		                       this.setStatictics(res.result.datas.meta.statistics);
		                    
		                    this.loading=false; 
		                    this.changeDetectorRef.detectChanges();
		               })
					);   
	         }
	}
	
	
	
    editData(event:any) {
	
		this.loading=true;
			if (this.loading) {
				this.all_datas.datas=Object.assign({}, this.dem_forms);
				this._options["sorted"]=this.all_datas;
				
				this.dem_forms=[];
				this.all_datas={};
				
				this.addFilters();
				this.subs.push(
					this.listService.export(this.listCode,this._options).subscribe(
				     (res: JSONRpcResponse) => {
	                    console.log("editData SYNTHESE",res);  
	                    
	                    if (res.result
	                    && res.result.datas!=undefined
	                    && res.result.datas.datas!=undefined
	                    ) {
							this.dem_forms= res.result.datas.datas;
							this.all_datas=res.result.datas;
							if (res.result.datas.url!=undefined) {
								//window.open(res.result.datas.url);
								const dial=this.dialogService.open(LoadDialogComponent, {
												               data: {
												                   url: res.result.datas.url
												               },
															   height: "95vh",
															   width: "80%",
															   minimizable: true,
															   maximizable: true,
															   draggable: true,
												           }, (res: any) => {
												               
								})
							}	
	                    }
	                    if (res.result
	                    && res.result.meta!=undefined)
	                       this.setStatictics(res.result.meta);
	                    
	                    console.log("editData dem_forms",this.dem_forms);  
	                    this.loading=false; 
	                    this.changeDetectorRef.detectChanges();
	               })
				   
				 );  
	         }
	    
	
	}
	
	resetFilterDataPage() {
		this.dataFormInput=[];
        this.dataInstructionInput=[];
		this.dataDateBeginInput=null;
		this.dataDateBeginEndInput=null;
				
         this.changeDetectorRef.detectChanges();
	     this.loadData(null);
	}
	
	
	saveFilters() {
		//let listPress = this.listpressets
		
		this.addFilters();
		this.removeFilter("dossier");
		
		this.dialogService.open(SaveFiltersDialog, {
			draggable: true,
		}, (result) => {
			if (result) {
				this.listService
					.setfilter(this.listCode, result, this._options.filters)
					.subscribe((res: JSONRpcResponse) => {
						console.log("saveFilters",res);
						if (res.result && res.result.length>0) {
							for(let i=0;i<res.result[0].filtres.length;i++)
			  				   res.result[0].filtres[i].personal=true;
							this.setPresset(this.actions.concat(res.result[0].filtres));
						}
						
					})
			}
		})
	}

	setPresset(pressets: any[]) {
		this.listpressets = pressets
	}

    getStoredFilters() {
		this.actions=[];
		this.subs.push(
			this.pageService.get(this.listCodePage).subscribe((res: JSONRpcResponse) => {
				console.log("getPageAction",res);
				if (res.result && res.result.actions!=undefined && res.result.actions.length>0) {
					for(let i=0;i<res.result.actions.length;i++) {
						let action:any=res.result.actions[i];
						
						action.personal=false;
						action.valeur=JSON.stringify(action.parametre);
						this.actions.push(action);
					}
					
					//this.actions=res.result.actions;
				}
				
		   })
		 );
	}

    getFilters() {
	    //console.log("getFilters");
		this.listService.getFilterList(this.listCode).subscribe((res: JSONRpcResponse) => {
			if (res.result && res.result.filtres!=undefined) {
				console.log("getFilters",res.result.filtres);
				
				for(let i=0;i<res.result.filtres.length;i++)
				  res.result.filtres[i].personal=true;
				
				
				this.setPresset(this.actions.concat(res.result.filtres))
			}
		})
		
		
		
	}
	
	pressetFilters(v: any) {
		console.log('pressetFilters',v)
		if (v.value!=undefined && v.value.valeur) {
			let setFilters = JSON.parse(v.value.valeur)
			
			this.dataFormInput =[];
			this.dataInstructionInput=[];
			//console.log('pressetFilters2',setFilters);
			if (setFilters.formulaire.value!=undefined
			&& setFilters.formulaire.value.length>0
			) {
				for(let i=0;i<this.formularies.length;i++) {
				   if( setFilters.formulaire.value.includes(this.formularies[i].key))
						this.dataFormInput.push(this.formularies[i]);
			    }
				
			}
			if (setFilters.instruction.value!=undefined
			&& setFilters.instruction.value.length>0
			) {
				for(let i=0;i<this.typeInstru.length;i++) {
				   if( setFilters.instruction.value.includes(this.typeInstru[i].key))
						this.dataInstructionInput.push(this.typeInstru[i]);
			    }
				
			}
			
			if (setFilters.and.value!=undefined) {
				this.dataAndInput=setFilters.and.value
				
			}
			
			if (setFilters.synthesis.value!=undefined) {
				this.dataLimitSynthisInput=setFilters.synthesis.value
				
			}
			
			if (setFilters.filled.value!=undefined) {
				this.dataLimitFilledInput=setFilters.filled.value
				
			}
			
			if (setFilters.oncourse.value!=undefined) {
				this.dataInstuctionCourseInput=setFilters.oncourse.value
				
			}
	
			if (setFilters.begin!=undefined && setFilters.begin.value!=undefined) {
					this.dataDateBeginInput=setFilters.begin.value
							
			}
			
			if (setFilters.beginend!=undefined && setFilters.beginend.value!=undefined) {
				this.dataDateBeginEndInput=setFilters.beginend.value
										
			}
			
			
			
			//console.log('pressetFilters2',this.dataFormInput,this.dataInstructionInput);
			
			
			this.changeDetectorRef.detectChanges();
			
			this.loadData(null);
			
		} else this.resetFilterDataPage()
	}
	
   removePressetFilter(presset: any) {
		
		of(
			window.confirm('Etes-vous sûr de vouloir supprimer ce filtre ?')
		).subscribe((res) => {
			if (res) {
				this.listService.removefilter(presset.id).subscribe((res: JSONRpcResponse) => {
					
					if (res.result && res.result.length>0) {
							for(let i=0;i<res.result[0].filtres.length;i++)
			  				   res.result[0].filtres[i].personal=true;
							this.setPresset(this.actions.concat(res.result[0].filtres));
					}
					
					this.resetFilterDataPage()
				})
			}
		})
	}

	getAgeLibelle(ageDf){
		var tiersAge: string = '';
		if(ageDf.y > 0){
			tiersAge += ageDf.y;
			tiersAge += ageDf.y > 1? " ans": " an";
		}
		if(ageDf.m > 0){
			if(tiersAge.length>0)
				tiersAge += " "
			tiersAge += ageDf.m +" mois";
		}
		if(ageDf.d > 0){
			if(tiersAge.length>0)
				tiersAge += " "
			tiersAge += ageDf.d;
			tiersAge += ageDf.d > 1 ? " jours": " jour";
		}
		return tiersAge;
	}
	
	drop(event: CdkDragDrop<string[]>) {
	   moveItemInArray(this.dem_forms, event.previousIndex, event.currentIndex);
	  console.log("DossierPageSyntheseComponent drop event",event)
 }
	
}
